import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler);

export function TimelineChart({ data }) {
  const chartData = {
    labels: data.labels,
    datasets: [{
      label: 'Jours déclarés',
      data: data.data,
      borderColor: '#2563B0',
      backgroundColor: 'rgba(37, 99, 176, 0.1)',
      borderWidth: 2,
      fill: true,
      tension: 0.4,
      pointRadius: 5,
      pointBackgroundColor: '#2563B0',
      pointBorderColor: '#FFF',
      pointBorderWidth: 2,
      pointHoverRadius: 7
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: true },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.parsed.y.toFixed(1)} jours`
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: { display: true, text: 'Jours' }
      }
    }
  };

  return (
    <div className="chart-wrap" style={{ height: 180 }}>
      <Line id="chartTimeline" data={chartData} options={options} />
    </div>
  );
}


